import React, { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

import { Spinner } from '../Spinner';

import styles from './Button.module.scss';

export type TButtonColor =
    | 'primary'
    | 'success'
    | 'error'
    | 'warning'
    | 'gray'
    | 'transparent'
    | 'transparent-light'
    | 'light';
export interface IButtonProps
    extends Omit<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'prefix'> {
    color?: TButtonColor;
    variant?: 'primary' | 'secondary' | 'fab' | 'ghost';
    size?: 'small' | 'medium' | 'large';
    rounded?: 'full' | 'normal';
    loading?: boolean;
    fullWidth?: boolean;
    prefix?: ReactNode;
    suffix?: ReactNode;
    children?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, IButtonProps>(
    (
        {
            variant = 'primary',
            color = 'primary',
            type = 'button',
            size = 'large',
            rounded = 'normal',
            className,
            children,
            loading,
            prefix,
            suffix,
            fullWidth = false,
            ...props
        },
        ref,
    ) => {
        return (
            <button
                ref={ref}
                className={classNames(
                    styles.button,
                    styles[`variant-${variant}`],
                    styles[`size-${size}`],
                    styles[`color-${color}`],
                    styles[`rounded-${rounded}`],
                    styles[`fullWith-${fullWidth?.toString()}`],
                    {
                        [styles.withPrefix]: !!prefix,
                        [styles.withSuffix]: !!suffix,
                    },
                    className,
                )}
                type={type}
                {...props}
            >
                {prefix}
                {loading ? <Spinner color="inherit" /> : children}
                {suffix}
            </button>
        );
    },
);
